import axios from "axios";

const _apiUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
	baseURL: _apiUrl,
	headers: {
		'Content-Type': 'application/json'
	}
});

export default axiosInstance;
